import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { initMapLayered } from "~/controllers/map/map_layered";
import { initPosition } from "~/controllers/map/position";
import { Context2d, InfoObject } from "~/types/map";
import { createShape } from "../map/info_objects";
import L from "~/misc/2d/leaflet";
import { Icon as ExtraIcon, PointCircle } from "leaflet-extra-markers";

interface SignsData {

}

export default class extends Controller {
  connect() {
    console.log('pages/path_map.ts');
    $('body').css('height', '100%');
    $('html').css('height', '100%');
    $('.full-map-header>nav').css('margin-bottom', '0px');
    $(".select2.select2-container").css('width', '100%');

    const map = initMapLayered();
    map.tree.element.on("state_ready.jstree", function () {
      map.tree.check_node('basemap_winter', null);
    });
    console.log(map.data);
    initPosition(map);
    initPaths(map);
    initStops(map);

    function initPaths(map: Context2d) {
      const featureGroup = L.featureGroup().addTo(map);
      for (const infoObject of map.data.infoObjects) {
        infoObject.openPopup = function (e: any) {
          openPopupInner(infoObject, e);
        };

        const shapes = createShape(map, infoObject);
        const shape = shapes[0];
        const touch = shapes[1];
        shape.addTo(featureGroup);
        infoObject.marker = shape;
        if (touch) {
          touch.addTo(featureGroup);
        }
        (touch || shape).on('click', function (e: any) {
          infoObject.openPopup(e);
        });
      }

      map.flyToBounds(featureGroup.getBounds(), {
        duration: 0.5
      });
      //setTimeout(function () {
      //  map.data.infoObjects[1].openPopup();
      //}, 505);

      function openPopupInner(infoObject: InfoObject, e: any) {
        const latLng = e ? e.latlng : infoObject.marker.getCenter();
        L.popup().setLatLng(latLng).setContent(infoObject.description).openOn(map);
      }
    }

    function initStops(map: Context2d) {
      //map.tree.create_node('#', {
      //  id: 'stops',
      //  icon: 'bi-pie-chart-fill',
      //  text: "Korlátok"
      //});
      //
      //map.tree.element.on("check_node.jstree uncheck_node.jstree state_ready.jstree", refreshLayers);
      //function refreshLayers() {
      //  featureGroup.remove();
      //  map.tree.is_checked('stops') ? featureGroup.addTo(map) : null;
      //}
      const featureGroup = L.featureGroup().addTo(map);
      for (const sign of map.data.signs) {
        for (const coord of sign.coordinates) {
          const [lon, lat] = coord.split(",").map(Number);
          const icon = new ExtraIcon({
            contentHtml: `<i class="fa fa-${sign.icon}"></i>`,
            color: sign.color,
            scale: 0.7,
            //iconSize: [15, 15],
            //iconAnchor: [15, 15],
            svg: PointCircle
          });
          const marker = L.marker([lat, lon], { icon: icon }).addTo(featureGroup);
          marker.bindTooltip(sign.name);
          marker.on('click', function (e) {
            window.open(sign.url, "_blank");
          });
        }
      }

    }
  }

}
